// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"9937774b","182":"e038ef3d","205":"c0ed4ea5","478":"7dbac849","551":"3fe29a65","587":"43220b40","842":"4c9e51fc","878":"e25cdfd7","885":"cf118ebf","893":"038858b6","929":"7c98439d"}[chunkId] + ".chunk.js";
};